import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux/store";
import { FaEdit } from "react-icons/fa";
import { MdRemoveCircle } from "react-icons/md";
import { ComplaintInterface, ShowComplaintsContext } from "./types";
import { useTranslation } from "react-i18next";
import { hostName } from "../../requestMethods";

const DataComplaints: React.FC = () => {
  const { complaints } = useSelector((state: State) => state.complaints);

  const {  
    showEditModal, 
    setShowEditModal,
    showDeleteModal, 
    setShowDeleteModal,
    setSelectedComplaint,
  } = useContext(ShowComplaintsContext)

  const toggleEditComplaint = (complaint: ComplaintInterface) => { 
    setShowEditModal(!showEditModal)
    setSelectedComplaint(complaint)
  };

  const toggleDeleteComplaint = (complaint: ComplaintInterface) => {
    setShowDeleteModal(!showDeleteModal)
    setSelectedComplaint(complaint)
  };

  const { t } = useTranslation()

  return (
    <div className="flex flex-col border mt-3">
    <div className="overflow-x-auto">
      <div className="inline-block min-w-full sm:px-6 lg:px-8">
        <div className="overflow-hidden">
          <table className="min-w-full text-center text-sm font-light border border-black">
            <thead className="border-b font-medium bg-main text-white border-black">
              <tr>
                <th className="px-4 py-4 border-r border-black">{t("Nom complet")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Telephone")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Matricule")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Nom du Cabinet")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Nom du docteur")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Plainte")}</th>
                <th className="px-4 py-4 border-r border-black">{t("devis")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {complaints.map((complaint: ComplaintInterface, index) =>(
                <tr className="border-b bg-white border-black" key={index}>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {complaint.fullName}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {complaint.phone}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {complaint.RegNo}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {complaint.cabinetName}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {complaint.doctorName}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {complaint.message}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    <div className="flex justify-center">
                      {complaint.devis && 
                        <img className="rounded-full w-28 h-28" src={hostName + "imgs/complaints/" + complaint.devis} alt="ss"/>
                      }
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    <div className="flex justify-center">
                      <FaEdit
                        className="text-second text-2xl"
                        onClick={() => toggleEditComplaint(complaint)}
                      />
                      <MdRemoveCircle
                        className="text-red text-2xl"
                        onClick={() => toggleDeleteComplaint(complaint)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  );
};

export default DataComplaints;
